import "./login.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Logo from "../../Assets/Images/icon.png";

const Login = () => {
  const [emailL, setEmailL] = useState("");
  const [passwordL, setPasswordL] = useState("");
  const [loginError, setLoginError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogIn = async () => {
    setLoginError("");

    const userToLogin = {
      email: emailL,
      password: passwordL,
    };

    try {
      setLoading(true);

      const response = await axios.post(
        "https://api.arkiva.gov.al/api/users/login",
        userToLogin,
      );

      if (response.data.type === "error") {
        setLoginError(response.data.message);
        return;
      }

      if (response.data.requires2FA) {
        // Save temporary information only
        sessionStorage.setItem("twoFactorUserId", response.data.userId);

        sessionStorage.setItem("twoFactorEmail", response.data.email);

        navigate("/verify-2fa");
      }
    } catch (error) {
      console.error(error);

      setLoginError(
        error.response?.data?.message ||
          "Ndodhi një gabim gjatë identifikimit.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="body-container">
      <div className="container">
        <div className="form-box login">
          <div className="login-box">
            <h1>Login</h1>

            <div className="input-box">
              <input
                type="text"
                placeholder="Email"
                value={emailL}
                onChange={(e) => setEmailL(e.target.value)}
              />

              <i className="bx bxs-user"></i>
            </div>

            <div className="input-box pass">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={passwordL}
                onChange={(e) => setPasswordL(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogIn();
                  }
                }}
              />

              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={`fa-solid ${
                    showPassword ? "fa-eye-slash" : "fa-eye"
                  }`}
                ></i>
              </button>

              {loginError && <div className="error">{loginError}</div>}
            </div>

            <div className="forgot">Forgot Password</div>

            <button className="btn" onClick={handleLogIn} disabled={loading}>
              {loading ? "Duke u identifikuar..." : "Login"}
            </button>
          </div>
        </div>

        <div className="toggle-box">
          <div className="toggle-panel toggle-left">
            <h1>Drejtoria e Përgjithshme e Arkivave!</h1>

            <img src={Logo} alt="logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
